import { FC } from "react";

import { useTranslation } from "react-i18next";
import { formatPrice } from "@testavivadk/utilities";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import CartLineItemDocuments from "./components/CartLineItemDocuments";
import RemoveLineItemButton from "./components/RemoveLineItemButton";

import { ICartLineItemProperties } from "./CartLineItem.types";

const CartLineItem: FC<ICartLineItemProperties> = ({ lineItem, nonPartnerPrice, cartId }) => {
  const { t } = useTranslation();

  return (
    <Card data-cy="cart-line-item">
      <CardContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 1 }}>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 1, minWidth: 0 }}>
            <Typography variant="h6" component="h3">
              {lineItem.title}
            </Typography>
            {lineItem.purchaseType != null && (
              <Chip size="small" label={t(`products.purchaseType.${lineItem.purchaseType}`)} />
            )}
          </Box>
          <RemoveLineItemButton cartId={cartId} lineItemId={lineItem.lineId} productType={lineItem.productType} />
        </Box>
        <CartLineItemDocuments documentIds={lineItem.externalDocumentIds} />
        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "baseline", gap: 1 }}>
          {nonPartnerPrice != null && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ textDecoration: "line-through", fontVariantNumeric: "tabular-nums" }}
            >
              {formatPrice(nonPartnerPrice)}
            </Typography>
          )}
          <Typography variant="subtitle1" sx={{ fontVariantNumeric: "tabular-nums" }}>
            {formatPrice(Number(lineItem.linePrice))}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CartLineItem;
